var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0742 0.650155C17.832 0.408005 17.5035 0.271973 17.161 0.271973C16.8185 0.271973 16.4901 0.408005 16.2478 0.650155L14.4214 2.47786L19.9007 7.95711L21.7271 6.1307C21.9692 5.88847 22.1053 5.55999 22.1053 5.21749C22.1053 4.87499 21.9692 4.5465 21.7271 4.30428L18.0742 0.650155ZM18.0742 9.78482L12.5937 4.30428L1.09787 15.8001C0.856409 16.0422 0.720776 16.3701 0.720703 16.712V20.3662C0.720703 20.7087 0.856789 21.0373 1.09902 21.2795C1.34126 21.5217 1.6698 21.6578 2.01237 21.6578H5.6652C6.00775 21.6578 6.33623 21.5216 6.57841 21.2794L18.0742 9.78353V9.78482Z",
    fill: "#8591A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.72bc13eba9fd9de5796a2d4f5067d358.svg";
export { ForwardRef as ReactComponent };